import {
  StructuralAssessmentCatalogsTable,
  StructuralAssessmentCatalogsTableFilters,
  useDefaultHtzStructuralAssessmentCatalogListRequest,
} from "@/services/backend/htz/inspection/components/structural-assessment-catalogs-table";
import { CreateStructuralAssessmentCatalogDialog } from "@/services/backend/htz/inspection/components/create-structural-assessment-catalog-dialog";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { NavLink } from "react-router";
import { ReactNode, useCallback, useState } from "react";

export function StructuralAssessmentCatalogsRoute() {
  const [request, setRequest] = useState(
    useDefaultHtzStructuralAssessmentCatalogListRequest(),
  );

  const renderRowLink = useCallback(
    (catalogId: string, children: ReactNode) => (
      <NavLink to={catalogId}>{children}</NavLink>
    ),
    [],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Kataloge für Konstruktive Beurteilungen")}</CardTitle>
        <CardDescription>
          {t(
            "Hier können Kataloge für Vorlagen für konstruktive Beurteilungen erstellt werden.",
          )}
        </CardDescription>
        <CardAction>
          <CreateStructuralAssessmentCatalogDialog />
        </CardAction>
      </CardHeader>
      <CardContent className="grid gap-2">
        <StructuralAssessmentCatalogsTableFilters
          request={request}
          onRequestChange={setRequest}
        />
        <StructuralAssessmentCatalogsTable
          request={request}
          onRequestChange={setRequest}
          renderRowLink={renderRowLink}
          hideBorder
        />
      </CardContent>
    </Card>
  );
}
